"use client";
import { cn as c } from "../utils/cn.js";
const _ = (o) => ({
  regular: o,
  primary: o,
  secondary: o,
  success: o,
  warning: o,
  danger: o,
  foreground: o,
  "social-android": o,
  "social-apple": o,
  "social-discord": o,
  "social-facebook": o,
  "social-gmail": o,
  "social-google": o,
  "social-instagram": o,
  "social-line": o,
  "social-mailru": o,
  "social-onlyfans": o,
  "social-outlook": o,
  "social-passkey": o,
  "social-patreon": o,
  "social-reddit": o,
  "social-snapchat": o,
  "social-steam": o,
  "social-telegram": o,
  "social-tiktok": o,
  "social-twitter": o,
  "social-vk": o,
  "social-whatsapp": o,
  "social-windows": o,
  "social-yahoo": o,
  "social-yandex": o,
  "social-youtube": o
}), r = _(
  c(
    "bg-component text-component-foreground",
    "hover:bg-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
    "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
  )
), e = _(
  c(
    "bg-component text-component-foreground shadow-component/40 shadow-lg",
    "hover:bg-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
    "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
  )
), l = {
  ..._(
    c(
      "text-component inset-ring-2 inset-ring-component bg-transparent",
      "hover:text-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
      "hover:inset-ring-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
      "active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
    )
  ),
  regular: c(
    "text-regular-foreground inset-ring-2 inset-ring-component bg-transparent",
    "hover:text-[oklch(from_var(--color-regular-foreground)_calc(l_+_0.1)_c_h)]",
    "hover:inset-ring-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
    "active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]",
    "active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "data-active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]",
    "data-active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
  )
}, a = {
  ..._(
    c(
      "bg-component/20 text-component",
      "hover:bg-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]/20",
      "hover:text-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
      "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/20",
      "active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/20",
      "data-active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
    )
  ),
  regular: c(
    "bg-component/40 text-component-foreground/90",
    "hover:bg-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]/40",
    "hover:text-[oklch(from_var(--color-foreground)_calc(l_+_0.1)_c_h)]",
    "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/40",
    "active:text-[oklch(from_var(--color-foreground)_calc(l_-_0.05)_c_h)]",
    "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/40",
    "data-active:text-[oklch(from_var(--color-foreground)_calc(l_-_0.05)_c_h)]"
  )
}, n = {
  ..._(
    c(
      "bg-regular/40 text-component inset-ring-2 inset-ring-regular",
      "hover:text-[oklch(from_var(--color-component)_calc(l_+_0.1)_c_h)]",
      "active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
    )
  ),
  regular: c(
    "bg-regular/40 text-regular-foreground inset-ring-2 inset-ring-regular",
    "hover:text-[oklch(from_var(--color-regular-foreground)_calc(l_+_0.1)_c_h)]",
    "active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]",
    "data-active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]"
  )
}, t = {
  ..._(
    c(
      "text-component bg-transparent",
      "hover:bg-component/20",
      "active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/20",
      "data-active:text-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/20"
    )
  ),
  regular: c(
    "text-regular-foreground bg-transparent",
    "hover:bg-component/60",
    "active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]",
    "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/60",
    "data-active:text-[oklch(from_var(--color-regular-foreground)_calc(l_-_0.05)_c_h)]",
    "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]/60"
  )
}, h = {
  ..._(
    c(
      "text-component inset-ring-2 inset-ring-component",
      "hover:bg-component hover:text-component-foreground",
      "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
      "data-active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
    )
  ),
  regular: c(
    "text-component-foreground inset-ring-2 inset-ring-component",
    "hover:bg-component hover:text-component-foreground",
    "active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "data-active:bg-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]",
    "data-active:inset-ring-[oklch(from_var(--color-component)_calc(l_-_0.05)_c_h)]"
  )
}, v = {
  solid: r,
  shadow: e,
  bordered: l,
  flat: a,
  faded: n,
  light: t,
  ghost: h
};
export {
  v as colorVariants
};
